export default {
  taxCorePages: {
    common: {
      yearly: "Yearly",
      quarterly: "Quarterly",
      monthly: "Monthly",
      biAnnualVat: "Bi-Annual VAT",
      biAnnualSalesTax: "Bi-Annual Sales tax",
      error: "Error",
      actions: "Actions",
      active: "Active",
      client: "Client",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      back: "Back",
      next: "Next",
      requiredData: "Required data",
      useLatin: "Use the Latin alphabet!",
      codeRequired: "Code is required",
      descriptionRequired: "Description is required",
      filterAria: "{{label}} filter",
    },
    dashboard: {
      pageTitle: "Home",
      discount: "{{value}}% discount",
      credits: "Credits",
      creditsCount_one: "{{count}} credit",
      creditsCount_other: "{{count}} credits",
      currentPlan: "Current plan",
      currentSubscriptionPlan: "Current subscription plan",
      details: "Details",
      manage: "Manage",
      getPremium: "Get Premium",
      free: "Free",
      nextBillingDate: "Next billing date: {{date}}",
      freePlans: {
        vat: "Start-up VAT",
        salesTax: "Free Sales Tax",
        epr: "Free EPR",
        omp: "Free OMP",
        invoice: "Free Invoice",
        authorize: "Free Authorize",
        default: "Free",
      },
      paidPlans: {
        vat: "VAT subscription",
        salesTax: "Sales tax subscription",
        epr: "EPR subscription",
        omp: "OMP subscription",
        invoice: "Invoice subscription",
        authorize: "Authorize subscription",
        default: "Subscription",
      },
    },
    news: {
      addNewsTitle: "Add News",
      article: "Article",
      date: "Date",
      language: "Language",
      title: "Title",
      shortDescription: "Short description",
      text: "Text",
      editNews: "Edit news",
    },
    dueDates: {
      taxNumber: "Tax number",
      periodicity: "Periodicity",
      deadline: "Deadline",
      reportingSummary: "Your reporting summary:",
    },
    threshold: {
      pageTitle: "Thresholds",
      calculationSuccessful: "The calculation was successful",
      periodTill: "Period till",
      europeanUnion: "European Union",
      surpassedDate: "Surpassed date",
      types: {
        unified: "unified",
        digital: "digital",
        goods: "goods",
      },
    },
    transactions: {
      taxableJurisdiction: "Taxable Jurisdiction",
      arrivalCountry: "Arrival Country",
      departureCountry: "Departure Country",
      transactionType: "Transaction type",
      taxRate: "TAX rate",
      taxAmount: "TAX amount",
      restore: "Restore",
      void: "Void",
      confirmVoid: "Confirm to void",
      confirmRestore: "Confirm to restore",
      voidQuestion: "Are you sure you want to void transaction {{id}}?",
      restoreQuestion: "Are you sure you want to restore transaction {{id}}?",
      warningMessage:
        'Your {{website}} transactions have "Warning" status from {{from}} to {{to}}. This may be due to incorrect Store settings. Please review and contact support.',
      emptyDescription: "Add transactions to see data",
      emptyButton: "Add transactions",
      eprCategory: "EPR category",
    },
    addTransactions: {
      pageTitle: "Add transactions",
      taxCalculation: "Tax (VAT or Sales Tax) calculation:",
      amazonReportHint:
        "Transactions can be requested from your Amazon business account if you generated the Sales Tax Report for this period in the Tax Document Library in Seller Central.",
      amazonReports: "Amazon reports",
    },
    stores: {
      siteParameters: "Site parameters",
      settingsTitle: "{{name}} - Settings",
      enterStoreName: "Enter the store name",
      enterStoreUrl: "Enter the store url",
      enterProjectUrl: "Enter the project url",
      number: "No",
      service: "Service",
      good: "Good",
      goods: "Goods",
      region: "Region",
      regionTooltipNote: "Please note:",
      regionTooltipEu:
        "If you select EU, your domain must include .eu (e.g. invoice.zoho.eu).",
      regionTooltipUsa:
        "If you select USA, your domain must include .com (e.g. invoice.zoho.com).",
      organizationId: "Organization ID",
      organizationIdTooltip:
        "If your account has multiple organizations, but you want to upload documents from only one specific organization, make sure to provide the Organization ID. If you don't specify the Organization ID, documents will be uploaded from all organizations in the account.",
      organizationIdPlaceholder: "Enter Organization ID (optional)",
      changeStatus: "Change status",
      statusChanged: "Status has been successfully changed",
      integratedWith: "{{label}} integrated with {{platform}}",
      statusWith: "{{label}} with {{platform}}",
      statuses: {
        setup: "Website was created",
        pending_auth: "Pending integration",
        ready: "Ready for testing",
        active: "Active",
        archive: "Archived integration",
        error: "Integration error",
      },
    },
    addStore: {
      enterPlatformStoreName: "Enter your {{platform}} store name",
      enterPlatformProjectName: "Enter your {{platform}} project name",
      enterPlatformData: "Enter your {{platform}} data",
      connectPlatform: "Connect {{platform}}",
      submitProject: "Submit project",
      customProject: "No, I have custom project",
      defaultWarehouse: "Default warehouse",
      selectCountry: "Select country",
      integrationGuide: "Integration guide",
      storeConnection: "Store connection",
      detailedInstructions:
        "Detailed instructions for enabling integration are in our",
      guide: "guide",
      chargebeeSubdomain: "Chargebee Subdomain",
      requestIntegrationTitle: "Request for {{name}} integration.",
      requestIntegrationDescription:
        "Do you want to order integration with {{name}}?",
      orderIntegration: "Order Integration",
    },
    clients: {
      pageTitle: "My clients",
      helmet: "Clients",
      addClient: "Add client",
      addClients: "Add clients",
      company: "Company",
      assignedUsers: "Assigned users",
      deleteQuestion: "Are you sure you want to delete the client {{name}}?",
      noClients: "There are no clients",
      noClientsDescription: "To see clients, you need to add them first",
    },
    addClient: {
      pageTitle: "Add new client",
      step: "Step {{number}}",
      placeOfEstablishment: "Place of establishment",
      salesTaxPermitNumber: "Sales tax permit number",
      provideDocuments: "Please provide us with some documents",
      provideDocumentsList:
        "Please provide us with the following documents of the client:",
      tradeRegisterExtract: "Trade (Commercial) Register Extract",
      vatCertificates: "VAT Certificates (for reporting countries)",
      taxCertificates: "Tax Certificates (for reporting countries)",
      powerOfAttorney: "Power of Attorney (concluded between you and the client)",
      directorOfCompany: "Director of the company",
      appointResponsible: "Appoint the responsible person",
      addResponsible: "Add responsible person",
      chooseTeamMember: "Choose someone from your team or add another team member",
      responsiblePerson: "Responsible person:",
      useLatinSpecial: "Use the Latin alphabet and special characters!",
    },
  },
};
